import React, { Component } from "react"
import { throttle } from "throttle-debounce"
import HowItWorks from "./howItWorks"
import InTheNews from "../../components/InTheNews/InTheNews"
import PageNav from "./PageNav"

import "./homePageContent.scss"

class HomePageContent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentSlide: 0,
      sliderPosition: 0,
      toolType: "cios",
      selectedToolImage: null,
    }
  }

  updateCurrentSlide = ({ toolType, name }, slide) => {
    this.trackClick(name, "#who-we-serve")

    let sliderWidth = document
      .querySelector(".slider-view")
      .getBoundingClientRect().width
    let sliderPosition = -Math.abs(slide * 100)

    this.setState(
      {
        currentSlide: slide,
        sliderPosition: sliderPosition,
        selectedToolImage: null,
      },
      this.onToolTypeChange(toolType)
    )
  }

  handleScroll = (container, els) => {
    let location = container.getBoundingClientRect().top
    if (location < 300) {
      for (let i = 0; i < els.length; i++) {
        els[i].classList.add("animate")
      }
    } else if (location > 800) {
      for (let i = 0; i < els.length; i++) {
        els[i].classList.remove("animate")
      }
    }
  }

  setToolImage = (image) => {
    this.setState({ selectedToolImage: image })
  }

  onToolTypeChange = (toolType) => {
    this.setState(
      {
        toolType: toolType,
      },
      this.resetIconSelection()
    )
  }

  resetIconSelection = () => {
    let elem = document.querySelector(".how-it-works-tools")
    elem.querySelector(".filled").classList.remove("filled")
    elem.querySelector(".icon").classList.add("filled")
  }

  componentDidMount() {
    // track page
    this.props.trackPage("Home", {
      authenticated: false,
    })

    //variables
    let whySection = document.querySelector("#why-us")
    let circles = document.getElementsByClassName("CircularProgressbar")
    let container = document.querySelector("#home-page-container")

    let { hash } = this.props.location

    if (hash) {
      document.querySelector(hash).scrollIntoView()
    }

    window.addEventListener(
      "scroll",
      throttle(100, () => this.handleScroll(whySection, circles))
    )
  }
  componentWillUnmount() {
    let container = document.querySelector("#home-page-container")
    container.removeEventListener("scroll", this.handleScroll)
  }

  trackClick = (name, section) => {
    this.props.trackEvent(`Clicked "${name}"`, { section })
  }

  render() {
    let freeTrialLink = "/free-trial"

    return (
      <article id="public-page">
        {/* <!----- Top lending page ----> */}
        <PageNav trackClick={this.trackClick} />
        <section id="landing-page" className="page-section">
          <div className="page-container">
            <InTheNews />
            <h1 className="title">Enterprise Technology Research</h1>
            <div className="slogan">
              <p>
                <strong className="slogan__highlight">Opinions</strong> Only
                Exist Due to a{" "}
                <strong className="slogan__highlight">Lack</strong> of{" "}
                <strong className="slogan__highlight">Data</strong>.
              </p>
            </div>
            <p className="intro__paragraph">
              ETR is a primary technology market research firm, capturing
              real-time evaluations and spending intentions from thousands of
              enterprise-leading technologists.
            </p>
            {/* <figure className="fp-hero-image"></figure> */}
          </div>
        </section>
        {/* <!-------- why us section  -------> */}
        <section id="why-us" className="page-section">
          <div className="page-container">
            <div className="research-coverage">
              <h2 className="title">
                Track the minds and walletshare driving the enterprise
                technology landscape
              </h2>
              <ul className="coverage-list">
                <li>
                  <svg className="CircularProgressbar" viewBox="0 0 100 100">
                    <defs>
                      <filter
                        id="circleglow-a"
                        width="109.8%"
                        height="109.9%"
                        x="-4.9%"
                        y="-4.9%"
                        filterUnits="objectBoundingBox"
                      >
                        <feGaussianBlur in="SourceGraphic" stdDeviation="2" />
                      </filter>
                      <linearGradient
                        id="grad3"
                        x1="0%"
                        y1="0%"
                        x2="0%"
                        y2="100%"
                      >
                        <stop offset="50%" stopColor="#39F5FF" />
                        <stop offset="100%" stopColor="#30A6AC" />
                      </linearGradient>
                    </defs>
                    <path
                      className="CircularProgressbar-trail"
                      d="M 50,50
                      m 0,-46
                      a 46,46 0 1 1 0,92
                      a 46,46 0 1 1 0,-92
                    "
                      strokeWidth="5"
                      fillOpacity="0"
                    ></path>
                    <path
                      className="CircularProgressbar-path cricle1"
                      d="
                      M 50,50
                      m 0,-46
                      a 46,46 0 1 1 0,92
                      a 46,46 0 1 1 0,-92"
                      strokeWidth="5"
                      fillOpacity="0"
                      stroke="url(#grad3)"
                    ></path>
                    <path
                      className="CircularProgressbar-path cricle1"
                      d="
                      M 50,50
                      m 0,-46
                      a 46,46 0 1 1 0,92
                      a 46,46 0 1 1 0,-92"
                      strokeWidth="3"
                      fillOpacity="0"
                      stroke="url(#grad3)"
                      filter="url(#circleglow-a)"
                    ></path>
                    <text
                      className="CircularProgressbar-text"
                      x="23%"
                      y="55%"
                      fill="#fff"
                    >
                      4500+
                    </text>
                  </svg>
                  <p>Respondents </p>
                </li>
                <li>
                  <svg className="CircularProgressbar " viewBox="0 0 100 100">
                    <defs>
                      <filter
                        id="circleglow-a"
                        width="109.8%"
                        height="109.9%"
                        x="-4.9%"
                        y="-4.9%"
                        filterUnits="objectBoundingBox"
                      >
                        <feGaussianBlur in="SourceGraphic" stdDeviation="2" />
                      </filter>
                      <linearGradient
                        id="grad3"
                        x1="0%"
                        y1="0%"
                        x2="0%"
                        y2="100%"
                      >
                        <stop offset="50%" stopColor="#39F5FF" />
                        <stop offset="100%" stopColor="#30A6AC" />
                      </linearGradient>
                    </defs>
                    <path
                      className="CircularProgressbar-trail"
                      d="M 50,50
                      m 0,-46
                      a 46,46 0 1 1 0,92
                      a 46,46 0 1 1 0,-92
                    "
                      strokeWidth="5"
                      fillOpacity="0"
                    ></path>
                    <path
                      className="CircularProgressbar-path cricle2"
                      d="
                      M 50,50
                      m 0,-46
                      a 46,46 0 1 1 0,92
                      a 46,46 0 1 1 0,-92"
                      strokeWidth="5"
                      fillOpacity="0"
                      stroke="url(#grad3)"
                    ></path>
                    <path
                      className="CircularProgressbar-path cricle2"
                      d="
                      M 50,50
                      m 0,-46
                      a 46,46 0 1 1 0,92
                      a 46,46 0 1 1 0,-92"
                      strokeWidth="3"
                      fillOpacity="0"
                      stroke="url(#grad3)"
                      filter="url(#circleglow-a)"
                    ></path>
                    <text
                      className="CircularProgressbar-text"
                      x="23%"
                      y="48%"
                      fill="#fff"
                    >
                      $900+
                    </text>
                    <text
                      className="CircularProgressbar-text"
                      x="23%"
                      y="68%"
                      fill="#fff"
                    >
                      Billion
                    </text>
                  </svg>
                  <p>In Annual Technology Spend</p>
                </li>
                <li>
                  <svg className="CircularProgressbar " viewBox="0 0 100 100">
                    <defs>
                      <filter
                        id="circleglow-a"
                        width="109.8%"
                        height="109.9%"
                        x="-4.9%"
                        y="-4.9%"
                        filterUnits="objectBoundingBox"
                      >
                        <feGaussianBlur in="SourceGraphic" stdDeviation="2" />
                      </filter>
                      <linearGradient
                        id="grad3"
                        x1="0%"
                        y1="0%"
                        x2="0%"
                        y2="100%"
                      >
                        <stop offset="50%" stopColor="#39F5FF" />
                        <stop offset="100%" stopColor="#30A6AC" />
                      </linearGradient>
                    </defs>
                    <path
                      className="CircularProgressbar-trail"
                      d="M 50,50
                      m 0,-46
                      a 46,46 0 1 1 0,92
                      a 46,46 0 1 1 0,-92
                    "
                      strokeWidth="5"
                      fillOpacity="0"
                    ></path>
                    <path
                      className="CircularProgressbar-path cricle3"
                      d="
                      M 50,50
                      m 0,-46
                      a 46,46 0 1 1 0,92
                      a 46,46 0 1 1 0,-92"
                      strokeWidth="5"
                      fillOpacity="0"
                      stroke="url(#grad3)"
                    ></path>
                    <path
                      className="CircularProgressbar-path  cricle3"
                      d="
                      M 50,50
                      m 0,-46
                      a 46,46 0 1 1 0,92
                      a 46,46 0 1 1 0,-92"
                      strokeWidth="3"
                      fillOpacity="0"
                      stroke="url(#grad3)"
                      filter="url(#circleglow-a)"
                    ></path>
                    <text
                      className="CircularProgressbar-text"
                      x="25%"
                      y="55%"
                      fill="#fff"
                    >
                      90%+
                    </text>
                  </svg>
                  <p>Repeat Respondent Rate</p>
                </li>
              </ul>
            </div>
            <div className="research-coverage-comprised">
              <h3 className="title">
                <span>Survey sample comprised of</span>
              </h3>
              <ul className="surveys">
                <li>
                  <div className="percentage">
                    <span>34%</span>
                  </div>
                  <div className="survey">
                    <p>
                      {" "}
                      C-LEVEL - <br />
                      CIO, CTO, CISO, CEO/Founder, COO, Chief Architect, EVP
                    </p>
                  </div>
                </li>
                <li>
                  <div className="percentage">
                    <span>47%</span>
                  </div>
                  <div className="survey">
                    {" "}
                    <p>
                      {" "}
                      Senior IT Director, Head of IT Group, IT Technical Lead,
                      Principal Architect, Principal Engineer
                    </p>
                  </div>
                </li>
                <li>
                  <div className="percentage">
                    <span>19%</span>
                  </div>
                  <div className="survey">
                    {" "}
                    <p>
                      IT Manager, IT Analyst, IT Administrator, IT Consultant
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </section>
        {/* <!-------- who we serve section ------> */}
        <section id="who-we-serve" className="page-section">
          <div className="section-header">
            <h3 className="title">Leverage our ecosystem and insights</h3>
          </div>
          <div className="page-container">
            <div className="slider">
              <ul className="slide-menu">
                {sliderMenu.map((slide, i) => (
                  <li
                    key={i}
                    className={this.state.currentSlide === i ? "active" : ""}
                  >
                    <span
                      className="slide-link"
                      onClick={(_) => this.updateCurrentSlide(slide, i)}
                    >
                      {slide.name}
                    </span>
                  </li>
                ))}
              </ul>
              <div className="slider-view">
                <div
                  className="slides"
                  style={{
                    transform: `translate3d(${this.state.sliderPosition}%,0px,0px)`,
                  }}
                >
                  {sliderMenu.map((slide, i) => (
                    <div key={i} id={`slide-${i + 1}`} className="slide">
                      <p
                        dangerouslySetInnerHTML={{ __html: slide.description }}
                      />
                      <a
                        className="btn btn-light btn-outline how-it-work-link"
                        href="#how-it-works"
                        onClick={(_) =>
                          this.trackClick(slide.buttonText, "#who-we-serve")
                        }
                      >
                        {slide.buttonText}
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        <HowItWorks
          etrTools={etrTools}
          selectedTool={this.state.toolType}
          onToolTypeChange={this.onToolTypeChange}
          selectedToolImage={this.state.selectedToolImage}
          setToolImage={this.setToolImage}
          trackEvent={this.props.trackEvent}
        />
      </article>
    )
  }
}

let sliderMenu = [
  {
    name: "Enterprise Technology Vendor",
    toolType: "vendors",
    buttonText: "Tools For Vendors",
    description: `For almost 10 years, Global 2000 corporations have trusted ETR’s proprietary technology research to capture real-time market activity. ETR produces market research through standardized surveys and round table discussions, not analyst opinions – our data driven approach quantifies the narrative driving the technology landscape. Marketing, Investor Relations, Corporate Strategy and Corporate Venture Capital teams no longer need to rely on anecdotal evidence to make business decisions. Vendors covered in our surveys gain mindshare among global IT leadership & gain key insights into navigating their competitive landscapes.`,
  },
  {
    name: "Enterprise Leading Technologist",
    toolType: "cios",
    buttonText: "Tools For CIOs",
    description: `For almost 10 years, CIOs and IT executives have trusted ETR’s proprietary technology research to capture real-time market activity and make informed, data-driven decisions. IT departments are challenged by declining budgets and the ever changing IT landscape, and leadership must ensure the right technologies and services are being procured. As such, ETR has spent the last decade building a 4000 member global CIO community to track the pulse of enterprise IT spend.`,
  },
  {
    name: "Investor",
    toolType: "investors",
    buttonText: "Tools For Investors",
    description: `For almost 10 years, investment professionals globally have trusted ETR’s proprietary technology data during every step of the investment process. Mine millions of proprietary data-points, models, quantitative analyses and reports to better manage your portfolio.`,
  },
  {
    name: "Government",
    toolType: "government",
    buttonText: "Tools For Government",
    description: `IT leadership in Government rely on ETR to help them make informed, data-driven decisions - ETR was selected to market, assess and assist in the commercialization of emerging technologies for the Transition to Practice Program (TTP) at the DHS Science and Technology office.<br/><br/>Government IT departments are challenged by declining budgets and the ever changing IT landscape, and must be cost conscious and ensure the right technologies and services are being procured. As such, consumer data drives ETR’s recommendations, not analyst opinions – our data driven approach has improved the process government agencies use to procure and invest in technologies.`,
  },
]

let etrTools = [
  {
    type: "government",
    tools: [
      {
        position: "left",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/peer_benchmarking.png",
        icon: "peer-benchmarking",
        title: "Peer Benchmarking",
        text: {
          __html:
            "<strong>Benchmark your department’s IT architecture against your peers.</strong> We track enterprise IT spend by over 60 subsamples (Fortune 100, Large Financial Organizations, Midsize & Small Businesses, US Government, Healthcare, Large TelCo, etc.).",
        },
      },
      {
        position: "left",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/optimize_your_+procurement_process.png",
        icon: "optimized-your-procurement-process",
        title: "Optimize Your Procurement Process",
        text: {
          __html:
            "Market Positioning - ETR's proprietary models, platforms and visualization tools <strong>assist in vendor procurement</strong>, checks against your current install base and an assessment of your IT architecture",
        },
      },
      {
        position: "left",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/custome+market+assessment+.png",
        icon: "custom-market-assessment",
        title: "Custom Market Assessment",
        text: {
          __html:
            "ETR works with government IT departments to <strong>design custom surveys and analyze the results</strong>. IT departments will be provided with live and secure links to the <strong>real-time polling</strong> data so that they may track the data and results in real-time. Drill down surveys receive ~150 CIO indications within 24 hours.",
        },
      },
      {
        position: "left",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/technology+shifts.png",
        icon: "technology-shifts",
        title: "Technology Shifts",
        text: {
          __html:
            "Peer benchmarking tools <strong>measure share loss/gain against competitors.</strong> Our ability to quantify market share movements help our leading technologists procure best in breed technologies and Contain/Replace those soon to be obsolete.",
        },
      },
      {
        position: "right",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/reasoning.png",
        icon: "reasoning",
        title: "Reasoning",
        text: {
          __html:
            "Adoption + Replacement Drivers. <strong>Track the reasoning behind the enterprise spend</strong>, such as Long Term ROI, Cost, Compatibility with Existing IT Skills, Feature Set, and more. Easily analyze and compare <strong>why</strong> vendors are being deployed or replaced in the enterprise IT stack.",
        },
      },
      {
        position: "right",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/drill+downs.png",
        icon: "drill-downs",
        title: "Drill Downs",
        text: {
          __html:
            "Commission custom surveys with our research team. Our drill down surveys are carefully crafted and sampling is curated based on analytics. The end result: the <strong>right questions go to the right people,</strong> which results in thoughtful answers. Drill down surveys receive ~150 CIO indications within 24 hours.",
        },
      },
      {
        position: "right",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/understand+the+enterprise.png",
        icon: "understand-the-enterprise",
        title: "Understand the Enterprise",
        text: {
          __html:
            "View Fortune 500 enterprise IT budgets, directionally and sector/vendor specific. <strong>Identify disruptive/emerging technologies and vendors soon to be obsolete.</strong> Hone in on what the enterprise and your peers are Adopting/Replacing in minutes by filtering and ranking datasets.",
        },
      },
      {
        position: "right",
        image: "https://s3.amazonaws.com/dev-etr/images/etr-tools/venn.png",
        icon: "venn",
        title: "VENN",
        text: {
          __html:
            "ETR's events & content platform organizes round table discussions within our technology ecosystem of CIOs, tech companies, and investors. VENN pairs ETR’s quantitative findings of <strong>who, what, when</strong>  and <strong>where</strong>- with the vital qualitative reasoning of <strong>why</strong> vendors are seeing more or less spend.",
        },
      },
    ],
  },
  {
    type: "investors",
    tools: [
      {
        position: "left",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/zero+bias.png",
        icon: "zero-bias",
        title: "Zero Bias",
        text: {
          __html:
            "<strong>Objectively benchmark </strong>end user data against vendor commentary, understand short & long-term technology trends, and <strong>make systematic investment decisions </strong>year after year. ETR has collected nearly a decade of data from 4000+ CIOs.",
        },
      },
      {
        position: "left",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/time_series_analysis.png",
        icon: "time-series-analysis",
        title: "Time Series Analysis",
        text: {
          __html:
            "<strong>Track critical datapoints over time,</strong> such as Tech Adoption %, Increase Spend %, Flat Spend %, Decrease Spend %, Tech Replacement %, Spend Velocity & Market Share. Easily compare metrics against vendor commentary to determine customer <strong>trends + short and long term effects</strong> of product & business changes.",
        },
      },
      {
        position: "left",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/custom_reports.png",
        icon: "custom-reports",
        title: "Custom Reports",
        text: {
          __html:
            "We put it together so you don’t have to. <strong> Understand the data-driven narrative - </strong>spending intentions among key subsamples, CIO reasoning, evaluations among Fortune 500 CIOs, drill downs into pressing questions, market share shifts and commentary from forward thinking technology end-users.",
        },
      },
      {
        position: "left",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/regressions%2Bforecasts.png",
        icon: "regressions-forecasts",
        title: "Regressions + Forecasts",
        text: {
          __html:
            "ETR provides <strong>forecasts using regression analysis.</strong> Our statistical models provide revenue forecasts for key public vendors. <strong>Easily compare forecasts against sell-side/consensus estimates.</strong>",
        },
      },
      {
        position: "right",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/reasoning.png",
        icon: "reasoning",
        title: "Reasoning",
        text: {
          __html:
            "Adoption + Replacement Drivers. <strong>Track the reasoning behind the enterprise spend</strong>, such as Long Term ROI, Cost, Compatibility with Existing IT Skills, Feature Set, and more. Easily analyze and compare <strong>why</strong> vendors are being deployed or replaced in the enterprise IT stack.",
        },
      },
      {
        position: "right",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/drill+downs.png",
        icon: "drill-downs",
        title: "Drill Downs",
        text: {
          __html:
            "Commission custom surveys with our research team. Our drill down surveys are carefully crafted and sampling is curated based on analytics. The end result: the <strong>right questions go to the right people,</strong> which results in thoughtful answers. Drill down surveys receive ~150 CIO indications within 24 hours.",
        },
      },
      {
        position: "right",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/marketshare.png",
        icon: "marketshare",
        title: "Market Share",
        text: {
          __html:
            "Which vendors are taking wallet and market share from peers? Quantify loss and gain against competitors. Analyze market share changes among any index or industry within the enterprise tech ecosystem, and <strong>determine whether market share shifts are temporary or indicative of long-term trends.</strong>",
        },
      },
      {
        position: "right",
        image: "https://s3.amazonaws.com/dev-etr/images/etr-tools/venn.png",
        icon: "venn",
        title: "VENN",
        text: {
          __html:
            "ETR's events & content platform organizes round table discussions within our technology ecosystem of CIOs, tech companies, and investors. VENN pairs ETR’s quantitative findings of <strong>who, what, when</strong>  and <strong>where</strong>- with the vital qualitative reasoning of <strong>why</strong> vendors are seeing more or less spend.",
        },
      },
    ],
  },
  {
    type: "cios",
    tools: [
      {
        position: "left",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/peer_benchmarking.png",
        icon: "peer-benchmarking",
        title: "Peer Benchmarking",
        text: {
          __html:
            "<strong>Benchmark your department’s IT architecture against your peers.</strong> We track enterprise IT spend by over 60 subsamples (Fortune 100, Large Financial Organizations, Midsize & Small Businesses, US Government, Healthcare, Large TelCo, etc.).",
        },
      },
      {
        position: "left",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/optimize_your_+procurement_process.png",
        icon: "optimized-your-procurement-process",
        title: "Optimize Your Procurement Process",
        text: {
          __html:
            "Market Positioning - ETR's proprietary models, platforms and visualization tools <strong>assist in vendor procurement</strong>, checks against your current install base and an assessment of your IT architecture.",
        },
      },
      {
        position: "left",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/custom_reports.png",
        icon: "custom-reports",
        title: "Custom Reports",
        text: {
          __html:
            "We put it together so you don’t have to. <strong> Understand the data-driven narrative - </strong>spending intentions among key subsamples, CIO reasoning, evaluations among Fortune 500 CIOs, drill downs into pressing questions, market share shifts and commentary from forward thinking technology end-users.",
        },
      },
      {
        position: "left",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/technology+shifts.png",
        icon: "technology-shifts",
        title: "Technology Shifts",
        text: {
          __html:
            "Peer benchmarking tools <strong>measure share loss/gain against competitors.</strong> Our ability to quantify market share movements help our leading technologists procure best in breed technologies and Contain/Replace those soon to be obsolete.",
        },
      },
      {
        position: "right",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/reasoning.png",
        icon: "reasoning",
        title: "Reasoning",
        text: {
          __html:
            "Adoption + Replacement Drivers. <strong>Track the reasoning behind the enterprise spend</strong>, such as Long Term ROI, Cost, Compatibility with Existing IT Skills, Feature Set, and more. Easily analyze and compare <strong>why</strong> vendors are being deployed or replaced in the enterprise IT stack.",
        },
      },
      {
        position: "right",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/drill+downs.png",
        icon: "drill-downs",
        title: "Drill Downs",
        text: {
          __html:
            "Commission custom surveys with our research team. Our drill down surveys are carefully crafted and sampling is curated based on analytics. The end result: the <strong>right questions go to the right people,</strong> which results in thoughtful answers. Drill down surveys receive ~150 CIO indications within 24 hours.",
        },
      },
      {
        position: "right",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/understand+the+enterprise.png",
        icon: "understand-the-enterprise",
        title: "Understand the Enterprise",
        text: {
          __html:
            "View Fortune 500 enterprise IT budgets, directionally and sector/vendor specific. <strong>Identify disruptive/emerging technologies and vendors soon to be obsolete.</strong> Hone in on what the enterprise and your peers are Adopting/Replacing in minutes by filtering and ranking datasets.",
        },
      },
      {
        position: "right",
        image: "https://s3.amazonaws.com/dev-etr/images/etr-tools/venn.png",
        icon: "venn",
        title: "VENN",
        text: {
          __html:
            "ETR's events & content platform organizes round table discussions within our technology ecosystem of CIOs, tech companies, and investors. VENN pairs ETR’s quantitative findings of <strong>who, what, when</strong>  and <strong>where</strong>- with the vital qualitative reasoning of <strong>why</strong> vendors are seeing more or less spend.",
        },
      },
    ],
  },
  {
    type: "vendors",
    tools: [
      {
        position: "left",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/peer_benchmarking.png",
        icon: "peer-benchmarking",
        title: "Peer Benchmarking",
        text: {
          __html:
            "<strong>Benchmark your department’s IT architecture against your peers.</strong> We track enterprise IT spend by over 60 subsamples (Fortune 100, Large Financial Organizations, Midsize & Small Businesses, US Government, Healthcare, Large TelCo, etc.).",
        },
      },
      {
        position: "left",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/optimize_marketing_%26_product_development.png",
        icon: "optimize-marketing-product-development",
        title: "Optimize Marketing & Product Development",
        text: {
          __html:
            "View spend across different product lines to <strong>hone in on key areas of strength and weakness</strong> to maximize Marketing ROI.",
        },
      },
      {
        position: "left",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/marketing+strategy+%26+branding.png",
        icon: "market-strategy-branding",
        title: "Market Strategy & Branding",
        text: {
          __html:
            "Use ETR’s time series models to gauge <strong>your trajectory</strong> in the wider market and determine which marketing changes are positively affecting <strong>long term growth + top line growth opportunities.</strong> Track critical metrics overtime such as customer Adoption & Acceleration, Replacement & Deceleration, and Market Share Shifts.",
        },
      },
      {
        position: "left",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/technology+shifts.png",
        icon: "technology-shifts",
        title: "Technology Shifts",
        text: {
          __html:
            "Peer benchmarking tools <strong>measure share loss/gain against competitors.</strong> Our ability to quantify market share movements help our leading technologists procure best in breed technologies and Contain/Replace those soon to be obsolete.",
        },
      },
      {
        position: "right",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/reasoning.png",
        icon: "reasoning",
        title: "Reasoning",
        text: {
          __html:
            "Adoption + Replacement Drivers. <strong>Track the reasoning behind the enterprise spend</strong>, such as Long Term ROI, Cost, Compatibility with Existing IT Skills, Feature Set, and more. Easily analyze and compare <strong>why</strong> vendors are being deployed or replaced in the enterprise IT stack.",
        },
      },
      {
        position: "right",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/drill+downs.png",
        icon: "drill-downs",
        title: "Drill Downs",
        text: {
          __html:
            "Commission custom surveys with our research team. Our drill down surveys are carefully crafted and sampling is curated based on analytics. The end result: the <strong>right questions go to the right people,</strong> which results in thoughtful answers. Drill down surveys receive ~150 CIO indications within 24 hours.",
        },
      },
      {
        position: "right",
        image:
          "https://s3.amazonaws.com/dev-etr/images/etr-tools/understand+the+enterprise.png",
        icon: "understand-the-enterprise",
        title: "Understand the Enterprise",
        text: {
          __html:
            "View Fortune 500 enterprise IT budgets, directionally and sector/vendor specific. <strong>Identify disruptive/emerging technologies and vendors soon to be obsolete.</strong> Hone in on what the enterprise and your peers are Adopting/Replacing in minutes by filtering and ranking datasets.",
        },
      },
      {
        position: "right",
        image: "https://s3.amazonaws.com/dev-etr/images/etr-tools/venn.png",
        icon: "venn",
        title: "VENN",
        text: {
          __html:
            "ETR's events & content platform organizes round table discussions within our technology ecosystem of CIOs, tech companies, and investors. VENN pairs ETR’s quantitative findings of <strong>who, what, when</strong>  and <strong>where</strong>- with the vital qualitative reasoning of <strong>why</strong> vendors are seeing more or less spend.",
        },
      },
    ],
  },
]

export default HomePageContent
